export { default } from './HeaderMobile';
